import { BookOpen, Palette, Layout, FolderTree, Rocket } from 'lucide-react';
import type { TutorialLevel } from '../components/TutorialLayout';

export const tutorialLevels: TutorialLevel[] = [
  {
    id: 'foundation',
    title: 'Level 1: Foundation',
    description: 'Get started with UIKit basics',
    icon: <BookOpen className="w-5 h-5" />,
    pages: [
      { id: 'what-is-uikit', title: 'What is UIKit?', path: '/tutorials/foundation/what-is-uikit' },
      { id: 'quick-start', title: 'Quick Start', path: '/tutorials/foundation/quick-start' },
      { id: 'components', title: 'Understanding Components', path: '/tutorials/foundation/components' },
    ],
  },
  {
    id: 'theming',
    title: 'Level 2: Theming',
    description: 'Master the theme system',
    icon: <Palette className="w-5 h-5" />,
    pages: [
      { id: 'semantic-colors', title: 'Semantic Colors', path: '/tutorials/theming/semantic-colors' },
      { id: 'using-themes', title: 'Using Themes', path: '/tutorials/theming/using-themes' },
      { id: 'dark-mode', title: 'Dark Mode', path: '/tutorials/theming/dark-mode' },
      { id: 'custom-themes', title: 'Custom Themes', path: '/tutorials/theming/custom-themes' },
    ],
  },
  {
    id: 'layouts',
    title: 'Level 3: Layouts',
    description: 'Build complete page structures',
    icon: <Layout className="w-5 h-5" />,
    pages: [
      { id: 'layout-system', title: 'Layout System', path: '/tutorials/layouts/layout-system' },
      { id: 'page-layout', title: 'PageLayout', path: '/tutorials/layouts/page-layout' },
      { id: 'admin-layout', title: 'AdminLayout', path: '/tutorials/layouts/admin-layout' },
      { id: 'auth-layout', title: 'AuthLayout', path: '/tutorials/layouts/auth-layout' },
      { id: 'other-layouts', title: 'Other Layouts', path: '/tutorials/layouts/other-layouts' },
    ],
  },
  {
    id: 'architecture',
    title: 'Level 4: Architecture',
    description: 'Project templates & structure',
    icon: <FolderTree className="w-5 h-5" />,
    pages: [
      { id: 'single-template', title: 'Single Template', path: '/tutorials/architecture/single-template' },
      { id: 'spa-template', title: 'SPA Template', path: '/tutorials/architecture/spa-template' },
      { id: 'multi-template', title: 'Multi Template', path: '/tutorials/architecture/multi-template' },
      { id: 'fbca-template', title: 'FBCA Template', path: '/tutorials/architecture/fbca-template' },
    ],
  },
  {
    id: 'production',
    title: 'Level 5: Production',
    description: 'Deploy & optimize',
    icon: <Rocket className="w-5 h-5" />,
    pages: [
      { id: 'code-generation', title: 'Code Generation', path: '/tutorials/production/code-generation' },
      { id: 'deployment', title: 'Deployment', path: '/tutorials/production/deployment' },
      { id: 'seo-performance', title: 'SEO & Performance', path: '/tutorials/production/seo-performance' },
    ],
  },
];

export const getAllTutorialPages = () => {
  return tutorialLevels.flatMap(level => level.pages);
};

export const getTotalTutorialCount = () => {
  return tutorialLevels.reduce((acc, level) => acc + level.pages.length, 0);
};
